<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalLogout">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"> <i class="fa fa-sign-out"></i> {{ $t('words.logout')}}</p>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    {{ $t('message.ask_logout') }}
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default float-left"><i
                            class="fa fa-times"></i>
                        {{ $t('words.cancel')}}</button>
                    <button type="button" @click="logout()" :class="appLayout.btn" :disabled="loading" class="btn"><i
                            class="fa fa-check"></i>
                        {{$t('words.logout')}} <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loading: false
            };
        },
    }
</script>